import { useMemo }    from 'react';
import Iframe         from 'components/YouTubeIframe';
import { makeStyles } from 'makeStyles';


const W = 4;
const H = 3;
 
const notice = `חידוש ביישומטיקה: מהיום תוכלו ליצור בעצמכם סרטונים ולשתף אותם עם התלמידים שלכם. פרטים בסרטון:`;
//const notice2 = `להסבר על רכישה ניתן לצפות בסרטון זה:`;
  
const useStyles = makeStyles()(() => ({
  notice: {
    marginBottom: 35,
    fontSize:     16, 
    lineHeight:   2
  }
}))
 
type YouTubeVideoProps = {
    containerStyle: any
}
const YouTubeVideo: React.FC<YouTubeVideoProps> = ({
    containerStyle
}) => {

  const YTStyle = useMemo(() => {

    const width  = containerStyle.width - 100;
    const height = (containerStyle.height - 100)/1.5;
  
    const bigWidth  = height * W / H;
    const bigHeight = width * H / W;

    if ( bigWidth > width ) {
      return {
        width:   width,
        height:  bigHeight,
      }
    }

    if ( bigWidth <= width ) {
      return {
        width:   bigWidth,
        height:  height,
      }
    }

    return {
      height: '100%',
      width:  '100%',
    }
    
  },[ containerStyle ]) 

  const { classes } = useStyles();

  return (
    <>
            <div className = { classes.notice }>
                { notice }
             </div> 
             <Iframe 
               color  = { '#FFF' }
               src    = { `https://www.youtube.com/embed/ydfflfPIfho?rel=0` }
               width  = { YTStyle.width }
               height = { YTStyle.height }
             />
    </>
  );
}


export default YouTubeVideo

